function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSpreading = function SvgSpreading(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "24-Spreading",
    id: "_24-Spreading"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.943,14H18a1,1,0,0,0,0-2H14a.988.988,0,0,0-.346.07.825.825,0,0,0-.086.037,1,1,0,0,0-.24.162.47.47,0,0,0-.043.035,1.017,1.017,0,0,0-.175.238c-.007.014-.009.03-.015.044a.719.719,0,0,0-.027.078,1,1,0,0,0-.058.284c0,.018-.01.034-.01.052v4a1,1,0,0,0,2,0v-.88l8.187,11.461a1,1,0,1,0,1.626-1.162Z",
    style: {
      fill: "#e7544c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.187,40.419,15,51.88V51a1,1,0,0,0-2,0v4c0,.018.009.034.01.052a1,1,0,0,0,.058.284.8.8,0,0,0,.027.078c.006.014.008.03.015.044a1.017,1.017,0,0,0,.175.238c.013.014.029.022.043.035a1,1,0,0,0,.24.162.825.825,0,0,0,.086.037A.988.988,0,0,0,14,56h4a1,1,0,0,0,0-2H15.943l8.87-12.419a1,1,0,0,0-1.626-1.162Z",
    style: {
      fill: "#e7544c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,50a1,1,0,0,0-1,1v.88L40.813,40.419a1,1,0,1,0-1.626,1.162L48.057,54H46a1,1,0,0,0,0,2h4a.988.988,0,0,0,.346-.07.825.825,0,0,0,.086-.037,1,1,0,0,0,.24-.162c.014-.013.03-.021.043-.035a1.017,1.017,0,0,0,.175-.238c.007-.014.009-.03.015-.044a.735.735,0,0,0,.027-.079.958.958,0,0,0,.058-.283c0-.018.01-.034.01-.052V51A1,1,0,0,0,50,50Z",
    style: {
      fill: "#e7544c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.99,12.948a.958.958,0,0,0-.058-.283.667.667,0,0,0-.027-.079c-.007-.014-.008-.03-.015-.044a1.017,1.017,0,0,0-.175-.238.47.47,0,0,0-.043-.035,1,1,0,0,0-.24-.162c-.028-.013-.056-.026-.086-.037A.988.988,0,0,0,50,12H46a1,1,0,0,0,0,2h2.057l-8.87,12.419a1,1,0,1,0,1.626,1.162L49,16.12V17a1,1,0,0,0,2,0V13C51,12.982,50.991,12.966,50.99,12.948Z",
    style: {
      fill: "#e7544c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 4,
    r: 3,
    style: {
      fill: "#34c1ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,7a5,5,0,0,1,5,5v5a2.006,2.006,0,0,1-2,2v6a2.006,2.006,0,0,1-2,2H5a2.006,2.006,0,0,1-2-2V19a2.006,2.006,0,0,1-2-2V12A5,5,0,0,1,6,7Z",
    style: {
      fill: "#34c1ad"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 40,
    r: 3,
    style: {
      fill: "#34c1ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,43a5,5,0,0,1,5,5v5a2.006,2.006,0,0,1-2,2v6a2.006,2.006,0,0,1-2,2H5a2.006,2.006,0,0,1-2-2V55a2.006,2.006,0,0,1-2-2V48A5,5,0,0,1,6,43Z",
    style: {
      fill: "#34c1ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,43a5,5,0,0,1,5,5v5a2.006,2.006,0,0,1-2,2v6a2.006,2.006,0,0,1-2,2H57a2.006,2.006,0,0,1-2-2V55a2.006,2.006,0,0,1-2-2V48A5,5,0,0,1,58,43Z",
    style: {
      fill: "#34c1ad"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 40,
    r: 3,
    style: {
      fill: "#34c1ad"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 4,
    r: 3,
    style: {
      fill: "#34c1ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,7a5,5,0,0,1,5,5v5a2.006,2.006,0,0,1-2,2v6a2.006,2.006,0,0,1-2,2H57a2.006,2.006,0,0,1-2-2V19a2.006,2.006,0,0,1-2-2V12A5,5,0,0,1,58,7Z",
    style: {
      fill: "#34c1ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,2c0-.083.018-.162.024-.244A2.992,2.992,0,1,0,8.976,4.244,2.989,2.989,0,0,1,4,2Z",
    style: {
      fill: "#21abab"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,25V19a2.006,2.006,0,0,1-2-2V12A5,5,0,0,1,7,7.1,5,5,0,0,0,1,12v5a2.006,2.006,0,0,0,2,2v6a2.006,2.006,0,0,0,2,2H7A2.006,2.006,0,0,1,5,25Z",
    style: {
      fill: "#21abab"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,38c0-.083.018-.162.024-.244a2.992,2.992,0,1,0,4.952,2.488A2.989,2.989,0,0,1,4,38Z",
    style: {
      fill: "#21abab"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,61V55a2.006,2.006,0,0,1-2-2V48a5,5,0,0,1,4-4.9A5,5,0,0,0,1,48v5a2.006,2.006,0,0,0,2,2v6a2.006,2.006,0,0,0,2,2H7A2.006,2.006,0,0,1,5,61Z",
    style: {
      fill: "#21abab"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,2c0-.083.018-.162.024-.244a2.992,2.992,0,1,0,4.952,2.488A2.989,2.989,0,0,1,56,2Z",
    style: {
      fill: "#21abab"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,25V19a2.006,2.006,0,0,1-2-2V12a5,5,0,0,1,4-4.9A5,5,0,0,0,53,12v5a2.006,2.006,0,0,0,2,2v6a2.006,2.006,0,0,0,2,2h2A2.006,2.006,0,0,1,57,25Z",
    style: {
      fill: "#21abab"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,38c0-.083.018-.162.024-.244a2.992,2.992,0,1,0,4.952,2.488A2.989,2.989,0,0,1,56,38Z",
    style: {
      fill: "#21abab"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,61V55a2.006,2.006,0,0,1-2-2V48a5,5,0,0,1,4-4.9A5,5,0,0,0,53,48v5a2.006,2.006,0,0,0,2,2v6a2.006,2.006,0,0,0,2,2h2A2.006,2.006,0,0,1,57,61Z",
    style: {
      fill: "#21abab"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 21,
    r: 4,
    style: {
      fill: "#e7544c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,32v5a2.006,2.006,0,0,1-2,2v6a2.006,2.006,0,0,1-2,2H31a2.006,2.006,0,0,1-2-2V39a2.006,2.006,0,0,1-2-2V32a5,5,0,0,1,10,0Z",
    style: {
      fill: "#e7544c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,19a3.984,3.984,0,0,1,.359-1.641,4,4,0,1,0,5.282,5.282A3.987,3.987,0,0,1,30,19Z",
    style: {
      fill: "#c74841"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,45V39a2.006,2.006,0,0,1-2-2V32a5,5,0,0,1,4-4.9A5,5,0,0,0,27,32v5a2.006,2.006,0,0,0,2,2v6a2.006,2.006,0,0,0,2,2h2A2.006,2.006,0,0,1,31,45Z",
    style: {
      fill: "#c74841"
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpreading, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/spreading.dec51a6b.svg";
export { ForwardRef as ReactComponent };